// extracted by mini-css-extract-plugin
module.exports = {"MenuButton":"_2k8aCIcoGjdbRI8uqI_sEN","Active":"_1LAKMxMsMlgnBjsPEpI6KJ","Text":"_2K4-5-GpxGdW7jpFleV-nW"};